<div [hidden]="!isActive">
  <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/components/vertical-tab/vertical-tab.component.html